import ButtonBase from '@mui/material/ButtonBase'
import styled from '@mui/material/styles/styled'
import { anchorCss } from '../Anchor/StyledAnchor.style'

/**
 * @deprecated Use `<ButtonLink>` instead
 */
export const StyledButtonAsLink = styled(ButtonBase, {
  shouldForwardProp: prop => prop !== 'underline' && prop !== 'bold',
})<{ underline?: boolean; bold?: boolean }>(anchorCss, {
  verticalAlign: 'baseline',
})
